import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { UserService } from 'src/app/core/services/user.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { CompanieService } from 'src/app/core/services/companie.service';

@Component({
  selector: 'app-companie-create',
  templateUrl: './companie-create.component.html',
  styleUrls: ['./companie-create.component.css']
})
export class CompanieCreateComponent implements OnInit {
  userForm: FormGroup;
  submitMode = false;
  companyForm: FormGroup;
  companyUserForm: FormGroup;

  constructor(
    private userService: UserService,
    private swalService: SwalService,
    private companieService: CompanieService,
  ) { }

  ngOnInit() {
    this.buildCompanyUserForm();
  }

  /**
   * Construção do formulário principal
   */
  buildCompanyUserForm() {
    this.companyUserForm = new FormGroup({
      company: this.buildCompanyFormGroup(),
      user: this.buildUserFormGroup()
    });
  }

  /**
   * Construção do formulário da empresa
   */
  buildCompanyFormGroup(): FormGroup {
    this.companyForm = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      expirationDate: new FormControl(null, [Validators.required])
    });

    return this.companyForm;
  }

  /**
   * Construção do formulário do usuário
   */
  buildUserFormGroup(): FormGroup {
    this.userForm = new FormGroup({
      username: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, [Validators.required])
    });

    return this.userForm;
  }

  async onSubmit() {
    this.submitMode = true;

    if (this.companyUserForm.invalid) {
      return this.swalService.fireErrorSwal('É necessário preencher todos os campos!');
    }

    const object = this.companyUserForm.value;
    this.companyUserForm.reset();
    this.submitMode = false;

    const confirmModal = await this.swalService.fireConfirmSwal();

    if (confirmModal.value) {

      const response = await this.userService.createUserWithCompany(object);

      if (response) {
        this.swalService.fireSuccessSwal(response.message);
      }

    }
  }
}
